import React, { useState, useRef, useEffect } from "react"
import "../../styles/Components/navabr.css" // Ensure this file exists and is accessible
import { message as antdMessage } from "antd"
import { clearUserCookies } from "../../utils/Cookies"
import { authApi } from "../../Apis/authApis"
import { useLocation, useNavigate } from "react-router-dom"
import { getUserCookies } from "../../utils/Cookies"
import { jwtDecode } from "jwt-decode"
import { useDispatch, useSelector } from "react-redux"
import { logout } from "../../ReduxToolKit/Slice/UserSlice"
import LanguageToggle from "./LanguageToggle"
import { translations } from "../../utils/Translation/staticTranslation"
import { resetStore } from "../../ReduxToolKit/Slice/StoreSlice"
import { resetMerchant } from "../../ReduxToolKit/Slice/MerchantsSlice"
import { clearOrganizationState } from "../../ReduxToolKit/Slice/OrganizationSlice"

const Navbar = ({ currentLanguage, toggleLanguage }) => {
  const user = useSelector((state) => state.user.user)
  const [open, setOpen] = useState(false)
  const [tutorialToggle, setTutorialToggle] = useState(false) // State for tutorial toggle
  const [showVideoModal, setShowVideoModal] = useState(false) // New state for video modal visibility
  const [videoError, setVideoError] = useState(false) // State for video error handling
  const dropdownRef = useRef(null) // Ref for dropdown
  const videoRef = useRef(null) // Ref for video element
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const lang = localStorage.getItem("language") || "ar"
  const navbar = translations[lang]?.navbar
  const highest_role =
    getUserCookies()?.token && jwtDecode(getUserCookies()?.token).highest_role

  // Normalize path to avoid trailing slash mismatches
  const normalizePath = (path) => {
    if (!path) return "/"
    const trimmed = path.replace(/\/+$/, "")
    return trimmed === "" ? "/" : trimmed
  }
  const currentPath = normalizePath(location.pathname)

  const fetchLogout = async () => {
    try {
      const response = await authApi.logout()
      dispatch(logout())
      dispatch(resetMerchant())
      dispatch(resetStore())
      dispatch(clearOrganizationState())

      clearUserCookies()
      if (response.status === 200) {
        antdMessage.success(navbar?.good_bye)
        navigate("/login")
      }
    } catch (error) {
      antdMessage.error(
        lang === "en"
          ? error.response.data.detail
          : error.response.data.detaiArabic
      )
      console.error("Error:", error)
    }
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  // Close video modal when pressing Escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setShowVideoModal(false)
      }
    }
    if (showVideoModal) {
      document.addEventListener("keydown", handleEscape)
    } else {
      document.removeEventListener("keydown", handleEscape)
    }
    return () => {
      document.removeEventListener("keydown", handleEscape)
    }
  }, [showVideoModal])

  // Reset video error when modal opens
  useEffect(() => {
    if (showVideoModal) {
      setVideoError(false)
    }
  }, [showVideoModal])

  const handleVideoError = () => {
    setVideoError(true)
    console.error("Video failed to load")
  }

  const handleVideoLoad = () => {
    setVideoError(false)
    console.log("Video loaded successfully")
  }

  return (
    <nav>
      <div className="d-flex justify-content-end align-items-center navabr-container">
        {/* dashboard toggle moved to dashboard pages */}
        {user?.role === "OWNER" && (
          <div
            className={` ${` ${
              lang === "ar"
                ? "watch-tutorial-button-ar"
                : "watch-tutorial-button"
            }`} d-flex align-items-center pointer`}
            onClick={() => setShowVideoModal(true)}
          >
            <img
              src="/Navbar/playButton.svg"
              alt="Watch Tutorial"
              className={` ${
                lang === "ar" ? "watch-tutorial-icon-ar" : "watch-tutorial-icon"
              }`}
            />
            {navbar?.watch_tutorial}
          </div>
        )}

        <div className="d-flex align-items-center">
          {/* Language Toggle */}
          <div className={` ${lang === "ar" ? "ml-20" : "mr-20"} `}>
            <LanguageToggle
              toggleLanguage={toggleLanguage}
              currentLanguage={currentLanguage}
            />
          </div>
          {/* Profile Icon/Image and Logout dropdown */}
          <div className="pointer" ref={dropdownRef}>
            <div
              className="relative profile-icon"
              onClick={() => setOpen(!open)}
            >
              <div className="pointer">
                {user?.profile_picture_url ? (
                  <img
                    width={28}
                    height={28}
                    src={user?.profile_picture_url}
                    alt=""
                    className={`${
                      lang === "ar" ? "ml-10" : "mr-10"
                    } border-radius-120`}
                  />
                ) : (
                  <img
                    width={28}
                    height={28}
                    src="/Navbar/personicon.svg"
                    alt=""
                    className={`${
                      lang === "ar" ? "ml-10" : "mr-10"
                    } border-radius-120`}
                  />
                )}
              </div>
              <div className="d-flex align-items-center">
                <p className="mb-0 text-13 text-141414 font-400">
                  {lang === "ar"
                    ? user?.name_arabic
                      ? user?.name_arabic
                      : user?.name_english
                    : user?.name_english}
                </p>
              </div>
              {open && (
                <div
                  className="absolute navbar-dropdown"
                  style={{
                    right: lang === "en" && "0",
                    zIndex: "1000",
                    left: lang === "ar" && "0",
                  }}
                >
                  {/* <div className="dropdown-option">Profile</div> */}
                  <div
                    className="dropdown-option pointer"
                    onClick={fetchLogout}
                  >
                    {navbar?.logout}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Video Tutorial Modal */}
      {showVideoModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setShowVideoModal(false)}
        >
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="video-modal-close-button"
              onClick={() => setShowVideoModal(false)}
            >
              &times;
            </button>
            {videoError ? (
              <div className="video-error-message">
                <p>Failed to load video. Please try again later.</p>
                <button
                  onClick={() => {
                    setVideoError(false)
                    if (videoRef.current) {
                      videoRef.current.load()
                    }
                  }}
                  className="retry-button"
                >
                  Retry
                </button>
              </div>
            ) : (
              <video
                ref={videoRef}
                controls
                className="video-player"
                onError={handleVideoError}
                onLoadedData={handleVideoLoad}
                preload="metadata"
              >
                <source
                  src={
                    lang === "ar"
                      ? "https://d6p3aufqwq8a9.cloudfront.net/Tutorial.mp4"
                      : "https://d6p3aufqwq8a9.cloudfront.net/Tutorial2.mp4"
                  }
                  type="video/mp4"
                />
                <p>Your browser does not support the video tag.</p>
              </video>
            )}
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
